export default {
  name: 'standardTable',
  props: {
    tableHead: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Boolean | Object
    },
    rowSelection: {
      type: Object
    },
    scroll: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    handleTableChange(val) {
      this.$emit('changeCurrent', val);
    }
  }
};